import dysmSocial from "../../assets/img/dysm-social.png";
import herbalife71 from "../../assets/img/herbalife71.png";
import pro3 from "../../assets/img/project3.png";
import bershop from "../../assets/img/bershop.png";
import falcon from "../../assets/img/falcon.png";

const WorkCardData = [
  {
    imgsrc: dysmSocial,
    title: "Dysm Social",
    text: "Mit React habe ich eine Social Media erstellt. In diesem Projekt habe ich Formik-yup benutzt. Mit Formik habe ich eine Authorization gemacht.",
    source: "https://dysm-social.netlify.app",
  },
  {
    imgsrc: herbalife71,
    title: "Herbalife 71",
    text: "Mit React habe ich eine Produkt Page für die Förderung erstellt. In diesem Projekt habe ich UI Material benutzt. Für Authorization habe ich mit Firebase gearbeitet.",
    source: "https://herbalife71.netlify.app/",
  },
  {
    imgsrc: falcon,
    title: "Falcon Chat-App",
    text: "Mit React habe ich eine Chat-App erstellt. In diesem Projekt habe ich mit Socket-io verbunden. Im Backend habe ich Node JS und Express benutzt.",
    source: "https://falcon-chatapp.netlify.app",
  },
  {
    imgsrc: bershop,
    title: "BER SHOP",
    text: "Mit React habe ich eine Online Shopping Page erstellt. In diesem Projekt habe ich FETCH API benutzt. Mit Bootstrap habe ich Responsive Design gemacht.",
    source: "https://bershop.netlify.app",
  },
  {
    imgsrc: pro3,
    title: "Learn-Redux",
    text: "Mit React habe ich eine Social Media erstellt. In diesem Projekt habe ich Formik-yup benutzt. Mit Formik habe ich eine Authorization gemacht.",
    source: "Link at buraya",
  },
  {
    imgsrc: pro3,
    title: "Travel WebSeite",
    text: "Mit React habe ich eine Social Media erstellt. In diesem Projekt habe ich Formik-yup benutzt. Mit Formik habe ich eine Authorization gemacht.",
    source: "Link at buraya",
  },
];

export default WorkCardData;
